module.exports = __webpack_public_path__ + "static/fonts/Raleway-ExtraBold.c9503ab0.ttf";